import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { TransactionListComponent } from '../transaction-list/transaction-list.component';

@Component({
  selector: 'app-transaction-account-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./transaction-account-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class TransactionAccountListComponent extends TransactionListComponent implements OnInit {

  accountId: string;

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.title = 'statement';
    this.entity = 'transaction';
    this.subentity = 'account';
  }

  getBody(): any {
    let query = ['account_id', '=', this.accountId || this.selectedAccount || this.username];
    const body = super.getBody();
    if (body.query) {
      body['query'] = body.query = [body.query, 'and', query];
    } else {
      body.query = query;
    }
    return body;
  }

}
